/*
 *
 * File JS per la Homepage
 *
 */

import "./general.scss";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import initHeader from "components/header/header";
import animateIn from "animations/animate-in/animate-in";
import button from "components/buttons/buttons";
import titleBox from "components/title-box/title-box";
import breadcrumbs from "components/breadcrumbs/breadcrumbs";
import cmsContent from "components/cms-content/cms-content";
import heroSlider from "imComponents/hero-slider/hero-slider";
import heroImage from "imComponents/hero-image/hero-image";
import fixedTicketButton from "components/fixed-ticket-button/fixed-ticket-button";
import accordion from "imComponents/accordion/accordion";
import customQuote from "components/custom-quote/custom-quote";
import textImgVar from "imComponents/text-img-var/text-img-var";
import textOnBg from "imComponents/text-on-bg/text-on-bg";
import cardsTextBg from "components/cards-text-bg/cards-text-bg";
import colTitleText from "components/col-title-text/col-title-text";
import carouselGallery from "imComponents/carousel-gallery/carousel-gallery";
import sliderCards from "components/slider-cards/slider-cards";
import card from "components/cards/card";
import sliderNews from "components/slider-news/slider-news";
import cardNews from "components/cards/card-news";
import boxImage from "components/box-image/box-image";
import footer from "components/footer/footer";
import sliderTabs from "components/slider-tabs/slider-tabs";
import boxGallery from "imComponents/box-gallery/box-gallery";
import archiveList from "components/archive-list/archive-list";
import textIframe from "components/text-iframe/text-iframe";
import partners from "components/partners/partners";
import contactForm from "components/contact-form/contact-form";
import marquee from "components/marquee/marquee";

//
//--------------------------------------------------------------------//
// INIT COMPONENTI
//--------------------------------------------------------------------//
function initAllComponents() {
    if (!document.querySelector("body.wp-admin")) {
        initHeader();
        heroSlider();
    }
    animateIn();
    accordion();
    fixedTicketButton();
    carouselGallery();
    sliderCards();
    sliderNews();
    sliderTabs();
    boxGallery();
    marquee();
}

if (document.querySelector("body.wp-admin")) {
    (function ($) {
        var initBlock = function ($block) {
            initAllComponents();
        };
        if (window.acf) {
            window.acf.addAction("render_block_preview", initBlock);
        }
    })(jQuery);
}

initAllComponents();
//--------------------------------------------------------------------//
